import { useState } from 'react'
import { Navigation, Tabs } from 'components'
import Flex from 'components/priority/Flex/Flex'
import {
  ButtonsDrawer,
  DropzoneDrawer,
  ExpandablesDrawer,
  PinturaDrawer,
  PlaygroundDrawer,
  StylesDrawer,
  TablesDrawer,
  TextboxDrawer,
} from './Drawers'

export const Showcase = () => {
  const [selectedTab, setSelectedTab] = useState('Playground')

  return (
    <>
      <Navigation />

      <Flex margin="42px 0 0 0">
        <Tabs
          selected={[selectedTab, setSelectedTab]}
          tabs={[
            { title: 'Playground', content: <PlaygroundDrawer /> },
            { title: 'Buttons', content: <ButtonsDrawer /> },
            { title: 'Styles', content: <StylesDrawer /> },
            { title: 'Pintura', content: <PinturaDrawer /> },
            { title: 'Textbox', content: <TextboxDrawer /> },
            { title: 'Tables', content: <TablesDrawer /> },
            { title: 'Expandables', content: <ExpandablesDrawer /> },
            { title: 'Dropzone', content: <DropzoneDrawer /> },
          ]}
        />
      </Flex>
    </>
  )
}

export default Showcase
